import React, { useEffect, useState } from "react"
import { Card, IndexTable } from "@shopify/polaris"
import GeolocationRedirectEntry from "./GeolocationRedirectEntry.jsx"
import GeolocationRedirectEntryForm from "./GeolocationRedirectEntryForm.jsx"
import { useTranslation } from "react-i18next"

const GeolocationRedirectSettings = ({ onSaveSettings, redirects }) => {
	const [t] = useTranslation()
	const [redirectEntries, setRedirectEntries] = useState([])

	const [showRedirectEntryForm, setShowRedirectEntryForm] = useState(false)

	const [isEditingRedirectEntry, setIsEditingRedirectEntry] = useState(false)
	const [redirectEntryToEdit, setRedirectEntryToEdit] = useState(null)
	const [redirectEntryToEditIndex, setRedirectEntryToEditIndex] =
		useState(null)

	const saveGeolocationSettings = () => {
		onSaveSettings({ redirects: redirectEntries })
	}

	const saveRedirectEntryChanges = (entry) => {
		if (isEditingRedirectEntry) {
			setRedirectEntries(
				redirectEntries.map((redirectEntry, i) => {
					if (i === redirectEntryToEditIndex) {
						return entry
					} else {
						return redirectEntry
					}
				}),
			)
		} else {
			setRedirectEntries([...redirectEntries, { ...entry, active: true }])
		}

		setShowRedirectEntryForm(false)
		setIsEditingRedirectEntry(false)
		setRedirectEntryToEdit(null)
		setRedirectEntryToEditIndex(null)
	}

	const editRedirectEntry = (redirectEntryIndex) => {
		setShowRedirectEntryForm(true)
		setIsEditingRedirectEntry(true)
		setRedirectEntryToEdit(redirectEntries[redirectEntryIndex])
		setRedirectEntryToEditIndex(redirectEntryIndex)
	}

	const deleteRedirectEntry = (redirectEntryIndex) => {
		setRedirectEntries(
			redirectEntries.filter(
				(entry, index) => index !== redirectEntryIndex,
			),
		)
	}

	const toggleRedirectEntry = (redirectEntryIndex) => {
		setRedirectEntries(
			redirectEntries.map((entry, index) => {
				if (index === redirectEntryIndex) {
					return { ...entry, active: !entry.active }
				} else {
					return entry
				}
			}),
		)
	}

	const closeRedirectEntryForm = () => {
		setShowRedirectEntryForm(false)
		setIsEditingRedirectEntry(false)
		setRedirectEntryToEdit(null)
		setRedirectEntryToEditIndex(null)
	}

	useEffect(() => {
		setRedirectEntries(redirects)
	}, [redirects])

	return (
		<div style={{ padding: "2rem" }}>
			{showRedirectEntryForm ? (
				<GeolocationRedirectEntryForm
					isEditingRedirectEntry={isEditingRedirectEntry}
					redirectEntryToEdit={redirectEntryToEdit}
					redirectEntryToEditIndex={redirectEntryToEditIndex}
					onSaveChanges={saveRedirectEntryChanges}
					onClose={closeRedirectEntryForm}
				/>
			) : (
				<>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: "2rem",
						}}
					>
						<h2 style={{ fontSize: "1.2rem", fontWeight: "600" }}>
							{t("protect.geolocation_redirect.redirects")}
						</h2>

						{!showRedirectEntryForm && (
							<button
								className="neu-background shadow neu-button"
								style={{
									padding: "0.5rem 1rem",
									display: "inline",
								}}
								onClick={() => setShowRedirectEntryForm(true)}
							>
								<span style={{ fontWeight: "600" }}>
									{t("protect.geolocation_redirect.create")}
								</span>
							</button>
						)}
					</div>

					<Card>
						<IndexTable
							itemCount={redirectEntries.length}
							headings={[
								{
									title: t(
										"protect.geolocation_redirect.active",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.title",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.redirect_to",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.countries_ips",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.maintain_path",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.edit",
									),
								},
								{
									title: t(
										"protect.geolocation_redirect.delete",
									),
								},
							]}
							selectable={false}
							resourceName={{
								singular: "Redirect",
								plural: "Redirects",
							}}
						>
							{redirectEntries.map((redirectEntry, i) => (
								<GeolocationRedirectEntry
									key={i}
									redirectEntryIndex={i}
									redirectEntry={redirectEntry}
									onEdit={editRedirectEntry}
									onDelete={deleteRedirectEntry}
									onToggle={toggleRedirectEntry}
								/>
							))}
						</IndexTable>
					</Card>

					<button
						className="neu-background shadow neu-button"
						style={{
							padding: "0.5rem 1rem",
							marginLeft: "auto",
							marginTop: "2rem",
						}}
						onClick={saveGeolocationSettings}
					>
						<span style={{ fontWeight: "600" }}>
							{t("common.save")}
						</span>
					</button>
				</>
			)}
		</div>
	)
}

export default GeolocationRedirectSettings
